<template>
  <v-row justify="center" align="center" class="pt-4" v-if="loading">
    <v-progress-circular
      :size="70"
      color="#5c648b"
      indeterminate
    ></v-progress-circular>
  </v-row>
  <div v-else>
    <DetailSection
      v-if="sessionSeriesDetail.type == 'Group session'"
      :details="sessionSeriesDetail"
    />
    <WorkshopDetails
      v-else-if="sessionSeriesDetail.type == 'Workshop'"
      :details="sessionSeriesDetail"
    />
    <WebinarDetails v-else :details="sessionSeriesDetail" />
  </div>
</template>

<script>
  import DetailSection from "@/views/Public/component/PublicSession/DetailSection";
  import WebinarDetails from "./Webinar/WebinarDetails.vue";

  // import Axios from "@/api/BaseAxios";
  // import { API_CLIENT_URL } from "@/constants/urls";
  import Keys from "../../constants/keys";
  import store from "../../store";
  import SessionSeriesApi from "../../api/common/SessionSeriesApi";

  import WorkshopDetails from "./Workshop/WorkshopDetails.vue";

  export default {
    // async asyncData({ $axios, $route }) {
    //   const requestParams = {};
    //   requestParams.id = 3;
    //   // const headers = {}
    //   const res = await $axios.get(
    //     "https://dev.api.eblity.com/session/session-series/details?id=" +
    //       $route.params.id
    //   );
    //   this.details = res.data.data;
    // },
    metaInfo() {
      return {
        htmlAttrs: {
          Eblity: "Session",
        },
        headAttrs: {
          nest: "Session",
        },
        meta: [
          { charset: "utf-8" },
          {
            name: "og:description",
            content: this.sessionSeriesDetail.sub_heading,
          },
          {
            name: "twitter:description",
            content: this.sessionSeriesDetail.sub_heading,
          },
          {
            name: "description",
            content: this.sessionSeriesDetail.sub_heading,
          },
          {
            name: "og:title",
            content: this.sessionSeriesDetail.title,
          },
          {
            name: "twitter:title",
            content: this.sessionSeriesDetail.title,
          },
          {
            name: "title",
            content: this.sessionSeriesDetail.title,
          },
          {
            name: "og:image",
            content: this.sessionSeriesDetail.thumbnail_path,
          },
          {
            name: "twitter:image",
            content: this.sessionSeriesDetail.thumbnail_path,
          },
          {
            name: "image",
            content: this.sessionSeriesDetail.thumbnail_path,
          },
          { name: "og:site_name", content: "Eblity" },
          { name: "twitter:site", content: "@Eblity_" },
          { name: "twitter:creator", content: "@Eblity_" },
        ],
      };
    },

    name: "PublicSessionDetails",
    components: {
      WorkshopDetails,
      DetailSection,
      WebinarDetails,
    },
    data() {
      return {
        id: -1,
      };
    },
    created() {
      this.id = this.$route.params.id;
      this.$store.state.sessionSeriesDetails.purchased = null;
      this.$store.state.sessionSeriesDetails.requested = null;
      this.$store.state.membership.isRenewMembership = false;
      this.getSessionSeriesDetails();
    },
    computed: {
      sessionSeriesDetail: {
        get() {
          return this.$store.state.sessionSeriesDetails.data;
        },
        set(value) {
          store.dispatch(
            "sessionSeriesDetails/updateSessionSeriesDetails",
            value
          );
        },
      },
      loading: {
        get() {
          return this.$store.state.sessionSeriesDetails.loading;
        },
        set(value) {
          store.dispatch(
            "sessionSeriesDetails/updateSessionSeriesDetails",
            value
          );
        },
      },
      selectedCountry: {
        get() {
          return this.$store.state.mainStore.country;
        },
        set(value) {
          store.dispatch("mainStore/updateCountry", value);
        },
      },
      // data() {
      //   return this.$store.state.sessionSeriesDetails.data;
      // }
    },
    watch: {
      loading() {
        console.log(this.loading);
      },
      selectedCountry() {
        this.getSessionSeriesDetails();
      },
    },
    methods: {
      getSessionSeriesDetails() {
        // var self = this;

        // self.loading = true;

        // const successHandler = (res) => {
        //   self.loading = false;
        //   console.log(res);
        //   self.data = res.data.data;
        // };
        //
        // const failureHandler = (res) => {
        //   console.log(res);
        //   self.loading = false;
        // };

        var requestParams = {};
        requestParams[Keys.ID] = this.id;
        requestParams[Keys.TYPE] = "Session";

        SessionSeriesApi.getSessionSeriesDetails(requestParams);
        // Axios.request_GET(
        //   API_CLIENT_URL.groupSessionSeriesDetails,
        //   requestParams,
        //   {},
        //   successHandler,
        //   failureHandler,
        //   false
        // );
      },
    },
    mounted() {
      // updating utm in store
      this.$store.state.userUTM.utm_source = this.$route.query.utm_source;
      this.$store.state.userUTM.utm_medium = this.$route.query.utm_medium;
      this.$store.state.userUTM.utm_campaign = this.$route.query.utm_campaign;
      console.log("utm_source", this.$store.state.userUTM.utm_source);
      console.log("utm_campaign", this.$store.state.userUTM.utm_campaign);
      console.log("utm_medium", this.$store.state.userUTM.utm_medium);
    },
  };
</script>

<style scoped></style>
